// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0bd9bfa9","404":"52da2bfd","787":"042f0aee"}[chunkId] + ".chunk.js";
};